module.exports = __webpack_public_path__ + "img/azo-z-logo.7ba1d565.png";